import { useTranslation } from "react-i18next";
import { StyledSelectIntWoController } from "@/components/styled/StyledSelectIntWoController";

type YearSelectProps = {
  onChange: (year?: number) => void;
  from?: number; // years in the past (default: 5)
  to?: number; // years in the future (default: 0)
  placeholder?: string;
  className?: string;
  isClearable?: boolean;
  isDisabled?: boolean;
  isSearchable?: boolean;
  defaultValue?: number;
};

export const StyledYearSelect = ({
  onChange,
  from = 5,
  to = 0,
  placeholder,
  className = "",
  isClearable = true,
  isDisabled = false,
  isSearchable = true,
  defaultValue,
}: YearSelectProps) => {
  const { t } = useTranslation("shared");
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: from + to + 1 }, (_, i) => currentYear - from + i);
  return (
    <StyledSelectIntWoController
      isClearable={isClearable}
      isSearchable={isSearchable}
      isDisabled={isDisabled}
      className={className}
      onChange={(e) => onChange(e?.value ? Number(e.value) : undefined)}
      options={years.map((y) => ({ label: String(y), value: y }))}
      placeholder={placeholder ?? t("yearSelect.placeholder")}
      defaultValue={defaultValue ? { value: defaultValue, label: String(defaultValue) } : undefined}
    />
  );
};
